import {useSelector} from 'react-redux'
import {useFilterContext} from '../context'

export const useFiltersCache = ({name: nameProp, orgCacheKey: orgCacheKeyProp} = {}) => {
	// You may preferably invoke this hook without passing any arguments, relying on the context's values.
	// That is not possible within the context itself, thus also allow passing the required props manually.
	const {name: nameContext, orgCacheKey: orgCacheKeyContext} = useFilterContext()
	const name = nameContext || nameProp
	const orgCacheKey = orgCacheKeyContext || orgCacheKeyProp

	const state = useSelector(state => (orgCacheKey ? state.components.filters?.[orgCacheKey]?.[name] : state.components.filters?.[name]))
	return state || {}
}
